// extracted by mini-css-extract-plugin
export default {"rootAbsolute":"Tags_rootAbsolute__AK98w","tag":"Tags_tag__5TWl9","statusCourse":"Tags_statusCourse__PWaH2"};